<script>
	import {Song, Types} from './song.js'
	import {Lists} from './lists.js'
	import {checkedSave, loadFromServer} from './server.js'
	import {generateCode} from './codegen.js'
	import RandomButons from './randombuttons.svelte'
	import ActiveSong from './activesong.svelte'
	import Editable from './editablelabel.svelte'
	import Stats from './stats.svelte'
	import SongList from './songlist.svelte'
	import Export from './exportsonglist.svelte'
	import Help from './help.svelte'
	import Sites from './sites.svelte'

	const initData = {
		config: {
			showhelp:"hide",
			showScore: false,
		},
		songs: [],
	 };

	function getDataFromStore() {
		try {
			const arch = localStorage.getItem("songs-store");
			const val = JSON.parse(arch);
			return val && val.songs ? val : initData;
		} catch (e) {
			return initData;
		}
	}

	let data = {};
	let id = "";

	updateSongs(getDataFromStore());
	if (data.id) {
		id = data.id;
		loadFromServer(data.id, onLoadData);
	}

	function updateSongs(d) {
		d.songs.forEach(s => Object.setPrototypeOf(s, Song.prototype));
		d.songs.forEach(s => s.convert());
		data = d;
	}

	function onLoadData(newData) {
		if (data.id !== newData.id || !data.stamp || data.stamp < newData.stamp) {
			updateSongs(newData);
		}
	}

	let saved = true;
	function save() {
		if (!data.id)
			data.id = generateCode();
		data.stamp = Date.now();
		localStorage.setItem("songs-store", JSON.stringify(data));
		id = data.id;
		checkedSave(data, (v) => saved = v);
		console.log("data saved " + data.songs.length);
	}

	let actSong = undefined;
	let activeSong;

	function dataChanged() {
		if (activeSong)
			activeSong.stopMetronome();
		save();
	}

	function newSongs(songs) {
		let d = data;
		d.songs = songs;
		updateSongs(d);
		dataChanged();
	}

	function setActSong(s) {
		if (activeSong)
			activeSong.stopMetronome();
		actSong = s;
		viewParams.rating = 0;
	}

	let lastActive = null;
	$: {
		if (lastActive && lastActive == actSong) {
			dataChanged();
		}
		lastActive = actSong;
	}

	function addNewSong(name) {
		let newSong = new Song(name);
		data.songs.push(newSong);
		setActSong(newSong);
		dataChanged();
	}

	function deleteSong(song) {
		if (confirm(`chceš opravdu smazat písničku ${song.name}?`)) {
			data.songs = data.songs.filter((it) => it !== song);
			dataChanged();
		}
	}

	function getFilteredItem(cat, songs) {
		const list = songs.filter((v) => v.type == cat.type);
		const now = Date.now();
		return {
			list: list,
			sorted: [...list].sort((a, b) => { return b.getScore(now) - a.getScore(now); }),
			noToday: list.filter(v => !v.last || v.dayDelay(now) > 0.5),
			category: cat,
		}
	}

	$: filteredSongs = Lists.map(it => getFilteredItem(it, data.songs));

	function mergeGenre(acc, song) {
		const key = song.genre ?? "";
		const group = acc[key] ?? [];
		return { ...acc, [key]: [...group, song] };
	}

	$: genres = data.songs.reduce(mergeGenre, {});

	$: sortedGenres = function() {
		let ar = Object.entries(genres);
		ar.sort((a, b) => b[1].length - a[1].length);
		return ar;
	}();

	function mergeTags(ar, song) {
		if (song.tags)
			song.tags.forEach((v) => {if (!ar.includes(v)) ar.push(v)});
		return ar;
	}

	$: tags = data.songs.reduce(mergeTags, []);

	var help = {};

	$: viewParams = {
		config: data.config,
		search: search.toLowerCase().trim(),
		rating: 0,
	}
	let exportComp = false;
	let search = "";
</script>

<style>
	.warn {
		color: brown;
		font-weight: bold;
	}

	#listhead * {
		margin-left: 1em;
	}

	:global(.songName) {
		font-weight: bold;
	}

	:global(li) {
		list-style-type: none;
	}

	:global(.frame) {
		border: 2px solid lightgray;
		border-radius: 1em;
		padding: 0.8em;
	}

	:global(.inblock) {
		display: inline-block;
	}

	:global(.trash) {
		color:crimson;
		font-weight: bold;
	}

	:global(.roundBox) {
		border-radius: 1em;
		padding: 0.8em;
	}

	:global(.typebtn) {
		border-radius: 0.6em;
		margin: 0.3em;
	}

	:global(.clickable) {
		cursor: pointer;
		font-weight: bold;
	}
</style>

<datalist id="genres">
{#each sortedGenres as gen}
	<option value="{gen[0]}"/>
{/each}
</datalist>

<datalist id="tags">
{#each tags as tag}
	<option value="{tag}"/>
{/each}
</datalist>

<div style="max-width:65em; margin:auto">

<RandomButons
	bind:lists={filteredSongs}
	bind:showScore={data.config.showScore}
	on:setActSong={e=>setActSong(e.detail)}
/>
<button style="color:red" on:click={help.switchHelp}>?pomoc?</button>

<Help bind:config={data.config} bind:this={help}/>
<Stats songs={data.songs} lists={filteredSongs}/>

<br>
<div style="background-color: Cornsilk; padding: 20px" class="roundBox">
	{#if actSong}
		<ActiveSong bind:song={actSong} params={viewParams} bind:this={activeSong}/>
	{:else if !data.songs.length}
		<span class="warn">chtělo by to přidat nějakou písničku!</span>
		<span class="warn">byly tu písničky a zmizely? napiš na ondrej.preclik@gmail.com najdeme to</span>
	{:else}
		<span class="warn">Tak co si dneska zahrajeme? Vylosuj si nahoře nebo vyber ručně ze seznamu :-)</span>
	{/if}
</div>
<br>
<div id="listhead">
	<Editable placeHolder="přidat novou písničku" reset=true callback={addNewSong}/>
	<span>kód seznamu: <Editable bind:value={id} placeHolder="id" length=5 lowCase=true callback={(v) => loadFromServer(v.toLowerCase(), onLoadData)}/></span>
	<img class="clickable" src="img/up-down-arrow-50.png" on:click={(e)=> exportComp = !exportComp} width="20" height="20" alt="export import"/>
	<input type="search" bind:value={search} placeholder="hledat" list="genres">
	{#if !saved}<img src="img/hold-on.gif" width="20" height="20" alt="saving"/>{/if}
</div>

{#if exportComp}
	<Export songs={data.songs} genres={sortedGenres} on:replaceSongs={e => newSongs(e.detail)}/>
{/if}

<SongList
	bind:lists={filteredSongs}
	params={viewParams}
	on:setActSong={e=>setActSong(e.detail)}
	on:deleteSong={e=>deleteSong(e.detail)}
/>

<Sites/>

</div>
